import {
  // This is the only place where we should be using matchPath
  // oxlint-disable-next-line no-restricted-imports
  matchPath,
} from 'react-router';

/**
 * Returns true if `href` is a prefix of `pathname` at segment boundaries.
 * Uses matchPath with `end: false` so that e.g. `/runs` matches `/runs/abc`
 * but `/run` does NOT match `/runs/abc`.
 */
export function matchPathPrefix(href: string, pathname: string): boolean {
  return matchPath({ path: href, end: false }, pathname) !== null;
}
